import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { EventFiltersComponent } from './event-filters.component';
import { SpnFiltersModule } from '../../../../../_components/spn-filters/spn-filters.module';

@NgModule({
  declarations: [
    EventFiltersComponent,
  ],
  imports: [
    CommonModule,
    FlexModule,
    FormsModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatIconModule,
    MatCheckboxModule,
    SpnFiltersModule,
  ],
  exports: [
    EventFiltersComponent,
  ],
})
export class EventFiltersModule {
}
